import React, { useState, useEffect } from "react";
import {
  Button,
  FormFieldSet,
  LogoLoader,
  showToast,
  NewTableAdv,
  Backdrop,
  TableAdv,
} from "../../../../components";
import JSZip from "jszip";
import * as XLSX from "xlsx";
import AccrodianComponent from "../../../InnerPages/ComponentsList/List/TableList/AccrodianComponent";
import { mapTableRows } from "../../../../utils";
import { useDispatch, useSelector } from "react-redux";
import { usePagination } from "../../../../hooks";
import { fetchRaDownloadSummaryReport } from "../../../../redux/slices/reports/reportsApi";
import { reportsStart } from "../../../../redux/slices/reports/reportsSlice";
//import { useLoginUser } from "../../../../hooks/useLoginUser";
import { formatWords2 } from "../../../../utils/stringUtils";
import { getEndOfDay, getStartOfDay } from "../../../../utils/common";

const RaReports = ({ selectedReport, setSelectedReport }) => {
  const dispatch = useDispatch();
  //const { value } = useSelector((state) => state.totalCount);
  const [selectedIds, setSelectedIds] = useState([]);
  const [rawRows, setRawRows] = useState([]);
  const raReportsData = useSelector((state) => state.reports) || {};
  const loading = useSelector((state) => state.reports) || {};
  const { page, limit, setPage, handleLimitChange } = usePagination(
    10,
    (newPage, newLimit) => {},
  );
  const [submissionRows, setSubmissionRows] = useState([]);
  const [withinPageLoading, setWithinPageLoading] = useState(false);
  // const [dateRange, setDateRange] = useState(() => {
  //   const today = new Date();
  //   const before10Days = new Date();
  //   before10Days.setDate(today.getDate() - 10);

  //   return {
  //     from: today.toISOString().split("T")[0],
  //     to: today.toISOString().split("T")[0],
  //   };
  // });
  const [dateRange, setDateRange] = useState(() => {
    const today = new Date();
    const before10Days = new Date();
    before10Days.setDate(today.getDate() - 10);

    return {
      from: new Date(),
      to: new Date(),
    };
  });
  //console.log(raReportsData?.raReports?.data?.updatedResponse)
  const [showOptions, setShowOptions] = useState(false);

  //const { user } = useSelector((state) => state.auth);

  const states = [
    ["Alabama", "AL"],
    ["Alaska", "AK"],
    ["Arizona", "AZ"],
    ["Arkansas", "AR"],
    ["California", "CA"],
    ["Colorado", "CO"],
    ["Connecticut", "CT"],
    ["Delaware", "DE"],
    ["Florida", "FL"],
    ["Georgia", "GA"],
    ["Hawaii", "HI"],
    ["Idaho", "ID"],
    ["Illinois", "IL"],
    ["Indiana", "IN"],
    ["Iowa", "IA"],
    ["Kansas", "KS"],
    ["Kentucky", "KY"],
    ["Louisiana", "LA"],
    ["Maine", "ME"],
    ["Maryland", "MD"],
    ["Massachusetts", "MA"],
    ["Michigan", "MI"],
    ["Minnesota", "MN"],
    ["Mississippi", "MS"],
    ["Missouri", "MO"],
    ["Montana", "MT"],
    ["Nebraska", "NE"],
    ["Nevada", "NV"],
    ["New Hampshire", "NH"],
    ["New Jersey", "NJ"],
    ["New Mexico", "NM"],
    ["New York", "NY"],
    ["North Carolina", "NC"],
    ["North Dakota", "ND"],
    ["Ohio", "OH"],
    ["Oklahoma", "OK"],
    ["Oregon", "OR"],
    ["Puerto Rico", "PR"],
    ["Pennsylvania", "PA"],
    ["Rhode Island", "RI"],
    ["South Carolina", "SC"],
    ["South Dakota", "SD"],
    ["Tennessee", "TN"],
    ["Texas", "TX"],
    ["Utah", "UT"],
    ["Vermont", "VT"],
    ["Virginia", "VA"],
    ["Washington", "WA"],
    ["West Virginia", "WV"],
    ["Wisconsin", "WI"],
    ["Wyoming", "WY"],
  ];
  const stateMap = Object.fromEntries(states);

  const handleDateRangeChange = (range) => {
    if (!range || !range.from || !range.to) return;
    // const fromISO = range.from.toISOString().split("T")[0];
    // const toISO = range.to.toISOString().split("T")[0];
    // const fromISO = range.from
    //   ? convertToUTC(dayjs(range.from).startOf("day").format("YYYY-MM-DD HH:mm"))
    //   : null;
    const fromISO = range.from ? range.from : null;

    // const toISO = range.to
    //   ? convertToUTC(dayjs(range.to).endOf("day").format("YYYY-MM-DD HH:mm"))
    //   : null;
    const toISO = range.to ? range.to : null;

    setDateRange({
      from: fromISO,
      to: toISO,
    });
  };

  const reportOptions = [
    { id: "reports_ats_rareport_radownloadsheet", name: "RA Download Sheet" },
    // { id: "Recruitment_Summary_Report", name: "Recruitment Summary Report" },
    // { id: "Bench_Sales_Summary_Report", name: "Bench Sales Summary Report" },
    // { id: "Recruiter_Report", name: "Recruiter Report" },
    // {
    //   id: "Bench_Sales_Daily_Submission_Report",
    //   name: "Bench Sales Daily Submission Report",
    // },
    // { id: "Client_vs_Job", name: "Client vs Job" },
    // { id: "France", name: "France" },
    // {
    //   id: "Recruitment_Daily_Submission",
    //   name: "Recruitment Daily Submission",
    // },
    // { id: "Bench_Sales_Summary_Report_2", name: "Bench Sales Summary Report" },
    // { id: "Placement_vs_Clients", name: "Placement vs Clients" },
  ];

  const rows = reportOptions.map((report, i) => ({
    id: i + 100,
    reportName: report,
    category: "Recruitment",
    type: "Standard Reports",
    // Favourite: "iii",
  }));

  // const columns = [
  //   {
  //     key: "reportName",
  //     label: "Report Name",
  //     render: (row) => (
  //       <div
  //         className="text-blue-600 cursor-pointer"
  //         onClick={() => setSelectedReport(row?.reportName?.id)}
  //       >
  //         {row?.reportName?.name}
  //       </div>
  //     ),
  //   },
  //   {
  //     key: "category",
  //     label: "Category",
  //   },
  //   {
  //     key: "type",
  //     label: "Type",
  //   },
  //   {
  //     key: "Favourite",
  //     label: "Favourite",
  //     render: (row) => (
  //       <Button
  //         type="icon"
  //         icon={"star"}
  //         variant="text"
  //         size="md-lg"
  //         color="black"
  //         className="text-gray-400"
  //       // onClick={() => console.log("delete", row)}
  //       />
  //     ),
  //   },
  // ];

  // const mappedRows = mapTableRows(rows, columns);

  const columns2 = [
    {
      key: "ids",
      label: "ID",
      render: (row) => <div className="text-blue-600">{row.ids}</div>,
    },
    {
      key: "reportName",
      label: "RA Name",
      render: (row) => <div className="text-blue-600">{formatWords2(row.reportName)}</div>,
    },
    {
      key: "pseudoName",
      label: "Pseudo Name",
      render: (row) => <div className="text-blue-600">{formatWords2(row.pseudoName)}</div>,
    },
    {
      key: "emailId",
      label: "Email Id",
      render: (row) => <div className="text-blue-600">{row.emailId}</div>,
    },
    {
      key: "position",
      label: "Position",
      render: (row) => <div className="text-blue-600">{row.position}</div>,
    },
    {
      key: "totalCompanies",
      label: "Total Companies",
      render: (row) => (
        <div className="text-blue-600">{row.totalCompanies}</div>
      ),
    },
    {
      key: "totalJobDetails",
      label: "Total Job Details",
      render: (row) => (
        <div className="text-blue-600">{row.totalJobDetails}</div>
      ),
    },
    {
      key: "totalContactDetails",
      label: "Total Contact Details",
      render: (row) => (
        <div className="text-blue-600">{row.totalContactDetails}</div>
      ),
    },
    {
      key: "totalValidCount",
      label: "Total Valid Count",
      render: (row) => (
        <div className="text-blue-600">{row.totalValidCount}</div>
      ),
    },
    {
      key: "totalInValidCount",
      label: "Total Invalid Count",
      render: (row) => (
        <div className="text-blue-600">{row.totalInValidCount}</div>
      ),
    },
    {
      key: "totalYetToValidCount",
      label: "Total YetTo Valid Count",
      render: (row) => (
        <div className="text-blue-600">{row.totalYetToValidCount}</div>
      ),
    },
  ];

  const fetchSubmissions = async () => {
    // if (!submissions?.length) return;

    try {
      const payload = {
        coll: "Job",
        pg: page,
        lim: limit,
        fil: {
          uiid: {
            type: "AG_TEAMCOUNT",
            value: [
              // dateRange.from,
              // dateRange.to
              getStartOfDay(dateRange.from),
              getEndOfDay(dateRange.to),
            ],
            userId: "", //user?.data?.uiid
          },
        },
        useAggregate: true,
        extret: "uiid firstName email role",
        queryMode: "AG_TEAMCOUNT",
      };
      dispatch(reportsStart(payload));
    } catch (err) {
      console.error("Error fetching submissions:", err);
    }
  };

  useEffect(() => {
  

    fetchSubmissions();
  }, [dateRange.to, dateRange.from, limit, page]);

  const data = raReportsData?.raReports?.data?.updatedResponse || [];
  // flatten if it's array-of-arrays, else keep single array
  const flattened = Array.isArray(data)
    ? data.flatMap((item) => (Array.isArray(item) ? item : [item]))
    : [];
  //console.log(flattened)
  const formattedRows = flattened.map((item, index) => {
    // normalize addedBy into a predictable shape
    let normalizedAddedBy = {};
    let addedByRaw = item.addedBy;

    if (typeof addedByRaw === "number" || typeof addedByRaw === "string") {
      normalizedAddedBy = { uiid: addedByRaw, firstName: String(addedByRaw) };
    } else if (typeof addedByRaw === "object" && addedByRaw !== null) {
      normalizedAddedBy = addedByRaw;
    }

    return {
      id: normalizedAddedBy.uiid ?? null,
      ids: index + 1,
      reportName:
        normalizedAddedBy.firstName ??
        normalizedAddedBy.uiid ??
        item.addedBy ??
        null,
      pseudoName: item.pseudoName ?? "-",
      emailId:
        normalizedAddedBy.email?.primary?.email ??
        normalizedAddedBy.email?.primary ??
        null,
      position: normalizedAddedBy.role?.name ?? "-",
      totalCompanies: item.totalCompanies ?? 0,
      totalJobDetails: item.totalJobs ?? 0,
      totalContactDetails: item.prospects ?? 0,
      totalValidCount: item.verifiedProspects ?? 0,
      totalInValidCount: item.unverifiedProspects ?? 0,
      totalYetToValidCount: item.invalidfieldProspects ?? 0,
      role: normalizedAddedBy.role?.name ?? null,
      userId: normalizedAddedBy.uiid ?? null,
      rawItem: item, // optional: keep original for debugging/actions
    };
  });

  useEffect(() => {
    setRawRows(formattedRows);
    setSubmissionRows(mapTableRows(formattedRows, columns2));
  }, [raReportsData]);

  //   useEffect(() => {

  // }, [dispatch,dateRange.to, dateRange.from, limit, page]);

  const fetchDownloadReportsData = async (uiids) => {
    try {
      setWithinPageLoading(true);
      const res = await fetchRaDownloadSummaryReport({
        coll: "Job",
        pg: 1,
        lim: 50000,
        fil: {
          addedBy: {
            type: "RA_SUMMARY_REPORT",
            value: [
              // dateRange.from,
              // dateRange.to
              getStartOfDay(dateRange.from),
              getEndOfDay(dateRange.to),
            ],
            userId: uiids, // no need [...uiids] if already array
            status: 1,
          },
        },
        useAggregate: true,
        ret: "uiid name website status jobs.uiid jobs.title jobs.status jobs.location jobs.addedOn jobs.addedBy jobs.description jobs.prospects.uiid jobs.prospects.firstName jobs.prospects.lastName jobs.prospects.mobile jobs.prospects.email jobs.prospects.designation jobs.prospects.inpersonResponseStatus",
        extret: "uiid firstName lastName",
      });

      const data = res?.data?.data || [];
      setWithinPageLoading(false);
      // console.log(data)
      // Flatten deeply nested jobs + prospects arrays
      const flattened = data.flatMap((company) => {
        const jobs = company.jobs || [];
        return jobs.flatMap((job) => {
          const prospects =
            job.prospects && job.prospects.length > 0 ? job.prospects : [null];            
          return prospects.map((prospect) => ({
            CompanyUIID: company?.uiid,
            CompanyName: formatWords2(company?.name),
            Website: company?.website,
            JobUIID: job?.uiid,
            JobTitle: formatWords2(job?.title),
            JobLocationCountry: job?.location?.country,
            JobLocationState: job?.location?.state,
            JobLocationCity: job?.location?.city,
            JobDescription: job?.description,
            JobAddedBy: job?.addedBy.uiid,
            raName: formatWords2(job?.addedBy.firstName),
            JobAddedOn: job?.addedOn,
            ProspectUIID: prospect?.uiid ?? "",
            ProspectFirstName: formatWords2(prospect?.firstName) ?? "",
            ProspectLastName: formatWords2(prospect?.lastName) ?? "",
            ProspectDesignation: formatWords2(prospect?.designation) ?? "",
            ProspectEmail: prospect?.email?.email ?? prospect?.email ?? "",
            ProspectMobileCode: prospect?.mobile?.code ?? "",
            ProspectMobileNumber: prospect?.mobile?.number ?? "",
          }));
        });
      });
      return flattened;
    } catch (err) {
      setWithinPageLoading(false);
      console.error("Error fetching download data:", err);
      return [];
    }
  };

  const handleDownload = async (type) => {
    try {
      if (!rawRows?.length) {
        console.warn("No data available for download");
        return;
      }

      const uiids =
        selectedIds.length > 0
          ? rawRows
              .filter(
                (r) =>
                  selectedIds.includes(r.id) ||
                  selectedIds.includes(String(r.id)),
              )
              .map((r) => r.userId)
              .filter(Boolean)
          : rawRows.map((r) => r.userId).filter(Boolean);

      if (!uiids.length) {
        console.warn("No user IDs found for fetching details");
        return;
      }

      const flattenedRows = await fetchDownloadReportsData(uiids);
      if (!flattenedRows?.length) {
        showToast("No Data to Download", "error", 2000);
        return;
      }


      // normalize / map rows — include addedBy fallbacks
      const mappedRows = flattenedRows.map((row) => ({
        // try multiple fallbacks because API might return different shapes
        AddedByUIID: row.JobAddedBy,
        AddedByName:
          row.AddedByName ??
          row.addedBy?.name ??
          row.addedByName ??
          row.addedBy?.firstName ??
          "",

        // CompanyUIID: row.CompanyUIID ?? "",
        RA_Name: formatWords2(row.raName) ?? "",
        CompanyName:
          formatWords2(row.CompanyName) ?? formatWords2(row.name) ?? "",
        JobTitle: formatWords2(row.JobTitle) ?? formatWords2(row.title) ?? "",
        //JobLocationCountry: `${row.JobLocationCity ?? row.location?.city ?? ""},${row.JobLocationState ?? row.location?.state ?? ""}`,
        JobLocation: `${(row.JobLocationCity ?? row.location?.city ?? "").trim()
            ? `${(row.JobLocationCity ?? row.location?.city).trim()},${stateMap[row.JobLocationState ?? row.location?.state ?? ""] ??
            row.JobLocationState ??
            row.location?.state ??
            ""
            }`
            : row.JobLocationState ?? row.location?.state ?? "-"
          }`,
        jobWebsite: row.Website ?? row.website ?? "",
        // JobUIID: row.JobUIID ?? row.uiid ?? "",
        // JobLocationState: row.JobLocationState ?? row.location?.state ?? "",
        //JobLocationCity: row.JobLocationCity ?? row.location?.city ?? "",
        contactFirstName:
          formatWords2(row.ProspectFirstName) ??
          formatWords2(row.prospect?.firstName) ??
          formatWords2(row.prospectFirstName) ??
          "",
        contactLastName:
          formatWords2(row.ProspectLastName) ??
          formatWords2(row.prospect?.lastName) ??
          formatWords2(row.prospectLastName) ??
          "",
        JobDescription: row.JobDescription ?? row.description ?? "",
        //JobAddedOn: row.JobAddedOn ?? row.addedOn ?? row.addedOnDate ?? "",
        //ProspectUIID: row.ProspectUIID ?? row.prospect?.uiid ?? row.prospectUIID ?? "",
        ProspectEmail: row.ProspectEmail ?? row.prospect?.email ?? "",
        ProspectDesignation: formatWords2(row.ProspectDesignation) ?? formatWords2(row.prospect?.designation) ?? "",
        //ProspectMobileCode:
        // row.ProspectMobileCode ?? row.prospect?.mobile?.code ?? row.mobile?.code ?? "",
        ProspectMobileNumber:
          row.ProspectMobileNumber ??
          row.prospect?.mobile?.number ??
          row.mobile?.number ??
          "",
        preStatus: "",
      }));

      const toDateOnly = (d) => {
        if (!d) return new Date().toISOString().split("T")[0];
        const dt = d instanceof Date ? d : new Date(d);
        return dt.toISOString().split("T")[0];
      };
      const fromOnly = toDateOnly(dateRange.from);
      const toOnly = toDateOnly(dateRange.to);
      const dateLabel =
        fromOnly === toOnly
          ? fromOnly
          : `${Math.floor((new Date(toOnly) - new Date(fromOnly)) / (1000 * 60 * 60 * 24))}days`;

      // Group by AddedByUIID / AddedBy fallback (so each addedBy gets its own file)
      // make rows deterministic so same RA rows are contiguous before grouping
      mappedRows.sort((a, b) => {
        const aKey =
          (a.AddedByUIID && String(a.AddedByUIID)) ||
          (a.AddedByName || a.RA_Name || "").trim().toLowerCase();
        const bKey =
          (b.AddedByUIID && String(b.AddedByUIID)) ||
          (b.AddedByName || b.RA_Name || "").trim().toLowerCase();
        if (aKey < bKey) return -1;
        if (aKey > bKey) return 1;
        return 0;
      });

      const groups = mappedRows.reduce((acc, r) => {
        // prefer a stable UIID string; fallback to AddedByName or a generated unknown key
        const key =
          (r.AddedByUIID && String(r.AddedByUIID)) ||
          (r.AddedByName && `name_${r.AddedByName}`) ||
          `unknown_${Math.random().toString(36).slice(2, 8)}`;

        acc[key] = acc[key] || [];
        acc[key].push({ ...r });
        return acc;
      }, {});

      // helpers that return Blob + filename (do NOT trigger download)
      const generateCsvBlobAndName = (rows, filenameBase) => {
        const headers = Object.keys(rows[0] || {});
        const csvRows = [
          headers.join(","),
          ...rows.map((item) =>
            headers
              .map((h) => `"${(item[h] ?? "").toString().replace(/"/g, '""')}"`)
              .join(","),
          ),
        ];
        const csvContent = csvRows.join("\n");
        const blob = new Blob([csvContent], {
          type: "text/csv;charset=utf-8;",
        });
        return { blob, filename: `${filenameBase}.csv` };
      };

      const generateXlsxBlobAndName = (rows, filenameBase) => {
        const rowsToWrite = rows.map((r) => ({ ...r }));
        const ws = XLSX.utils.json_to_sheet(rowsToWrite);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "RA Reports");
        const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const blob = new Blob([wbout], { type: "application/octet-stream" });
        return { blob, filename: `${filenameBase}.xlsx` };
      };

      // collect all generated files (blob + filename)
      const generatedFiles = [];

      for (const [key, rows] of Object.entries(groups)) {
        if (!rows || !rows.length) continue;
        const first = rows[0] || {};

        // create rows to export (strip internal helper keys)
        const exportRows = rows.map(
          ({ AddedByUIID, AddedByName, ...rest }) => rest,
        );

        // Choose a friendly label for filename: prefer AddedByName, else use the key
        // (we still use AddedByName for the filename only — it's not included in exportRows)
        const safeNamePart =
          (first.RA_Name && first.RA_Name.replace(/\s+/g, "_")) || key;
        //console.log(first)
        // ensure filename is safe and unique (add index if necessary)
        const filenameBase = `${safeNamePart}_${dateLabel}`.replace(
          /__+/g,
          "_",
        );

        const fileItem =
          type === "excel"
            ? generateXlsxBlobAndName(exportRows, filenameBase)
            : generateCsvBlobAndName(exportRows, filenameBase);

        generatedFiles.push(fileItem);
      }

      if (!generatedFiles.length) {
        showToast("No files generated for download", "error", 2000);
        return;
      }

      // decide whether user requested "all UIIDs"
      const isAllUiidsRequested = selectedIds.length === 0;

      // helper to trigger simple download of a blob
      const triggerBlobDownload = (blob, filename) => {
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.setAttribute("download", filename);
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
        showToast("Download Successfull", "success", 2000);
      };

      // If more than one file AND **all UIIDs were requested**, create zip and download single zip file
      if (generatedFiles.length > 1 && isAllUiidsRequested) {
        const zip = new JSZip();
        generatedFiles.forEach((f) => {
          zip.file(f.filename, f.blob);
        });

        const zipName = `RA_Reports_${dateLabel}.zip`;
        const zipBlob = await zip.generateAsync({ type: "blob" });

        triggerBlobDownload(zipBlob, zipName);
      } else if (generatedFiles.length > 1 && !isAllUiidsRequested) {
        // multiple files but user selected a subset -> download each file individually (one click per file)
        for (const f of generatedFiles) {
          triggerBlobDownload(f.blob, f.filename);
        }
      } else {
        // single file -> download directly
        const single = generatedFiles[0];
        triggerBlobDownload(single.blob, single.filename);
      }
    } catch (err) {
      console.error("Error during download:", err);
    }
  };

  // Create one Excel workbook (each RA = a sheet) OR zip of CSVs for "Download All Sheets"
  // Export ALL data into a single table (one XLSX sheet or one CSV file)
  const handleDownloadAll = async (type) => {
    try {
      if (!rawRows?.length) {
        console.warn("No data available for download");
        return;
      }

      // decide which uiids to fetch: if user selected some IDs, respect that; else use all
      const uiids =
        selectedIds.length > 0
          ? rawRows
              .filter(
                (r) =>
                  selectedIds.includes(r.id) ||
                  selectedIds.includes(String(r.id)),
              )
              .map((r) => r.userId)
              .filter(Boolean)
          : rawRows.map((r) => r.userId).filter(Boolean);

      if (!uiids.length) {
        console.warn("No user IDs found for fetching details");
        return;
      }

      const flattenedRows = await fetchDownloadReportsData(uiids);
      if (!flattenedRows?.length) {
        showToast("No Data to Download", "error", 2000);
        return;
      }

      // normalize / map rows — same mapping as your existing handleDownload
      const mappedRows = flattenedRows.map((row) => ({
        AddedByUIID: row.JobAddedBy,
        AddedByName:
          row.AddedByName ??
          row.addedBy?.name ??
          row.addedByName ??
          row.addedBy?.firstName ??
          "",
        RA_Name: formatWords2(row.raName) ?? "",
        CompanyName:
          formatWords2(row.CompanyName) ?? formatWords2(row.name) ?? "",
        JobTitle: formatWords2(row.JobTitle) ?? formatWords2(row.title) ?? "",
        //JobLocationCountry: `${row.JobLocationState ?? row.location?.state ?? ""},${row.JobLocationCity ?? row.location?.city ?? ""}`,
        // JobLocation: `${row.JobLocationCity ?? row.location?.city ?? ""},${
        //   stateMap[row.JobLocationState ?? row.location?.state ?? ""] ??
        //   row.JobLocationState ??
        //   row.location?.state ??
        //   ""
        // }`,
        JobLocation: `${(row.JobLocationCity ?? row.location?.city ?? "")
            ? `${(row.JobLocationCity ?? row.location?.city)},${stateMap[row.JobLocationState ?? row.location?.state ?? ""] ??
            row.JobLocationState ??
            row.location?.state ??
            ""
            }`
            : row.JobLocationState ?? row.location?.state ?? "-"
          }`,
        jobWebsite: row.Website ?? row.website ?? "",
        contactFirstName:
          formatWords2(row.ProspectFirstName) ??
          formatWords2(row.prospect?.firstName) ??
          formatWords2(row.prospectFirstName) ??
          "",
        contactLastName:
          formatWords2(row.ProspectLastName) ??
          formatWords2(row.prospect?.lastName) ??
          formatWords2(row.prospectLastName) ??
          "",
        JobDescription: row.JobDescription ?? row.description ?? "",
        ProspectEmail: row.ProspectEmail ?? row.prospect?.email ?? "",
        ProspectDesignation: formatWords2(row.ProspectDesignation) ?? formatWords2(row.prospect?.designation) ?? "",
        ProspectMobileNumber:
          row.ProspectMobileNumber ??
          row.prospect?.mobile?.number ??
          row.mobile?.number ??
          "",
        preStatus: "",
      }));
      // make rows deterministic so same RA rows are contiguous before grouping
      mappedRows.sort((a, b) => {
        const aKey =
          (a.AddedByUIID && String(a.AddedByUIID)) ||
          (a.AddedByName || a.RA_Name || "").trim().toLowerCase();
        const bKey =
          (b.AddedByUIID && String(b.AddedByUIID)) ||
          (b.AddedByName || b.RA_Name || "").trim().toLowerCase();
        if (aKey < bKey) return -1;
        if (aKey > bKey) return 1;
        return 0;
      });

      // create a single array with all rows (this replaces grouping + multi-file behavior)
      const exportRowsAll = mappedRows.map(
        ({ AddedByUIID, AddedByName, ...rest }) => rest,
      );

      if (!exportRowsAll.length) {
        showToast("No exportable rows found", "error", 2000);
        return;
      }

      // reuse your dateLabel logic for filename
      const toDateOnly = (d) => {
        if (!d) return new Date().toISOString().split("T")[0];
        const dt = d instanceof Date ? d : new Date(d);
        return dt.toISOString().split("T")[0];
      };
      const fromOnly = toDateOnly(dateRange.from);
      const toOnly = toDateOnly(dateRange.to);
      const dateLabel =
        fromOnly === toOnly
          ? fromOnly
          : `${Math.floor((new Date(toOnly) - new Date(fromOnly)) / (1000 * 60 * 60 * 24))}days`;

      // helpers (re-using patterns from your handleDownload)
      const generateCsvBlobAndName = (rows, filenameBase) => {
        const headers = Object.keys(rows[0] || {});
        const csvRows = [
          headers.join(","),
          ...rows.map((item) =>
            headers
              .map((h) => `"${(item[h] ?? "").toString().replace(/"/g, '""')}"`)
              .join(","),
          ),
        ];
        const csvContent = csvRows.join("\n");
        const blob = new Blob([csvContent], {
          type: "text/csv;charset=utf-8;",
        });
        return { blob, filename: `${filenameBase}.csv` };
      };

      const generateXlsxBlobAndName = (rows, filenameBase) => {
        const rowsToWrite = rows.map((r) => ({ ...r }));
        const ws = XLSX.utils.json_to_sheet(rowsToWrite);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "RA Reports");
        const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const blob = new Blob([wbout], { type: "application/octet-stream" });
        return { blob, filename: `${filenameBase}.xlsx` };
      };

      const filenameBase = `RA_Reports_All_${dateLabel}`.replace(/__+/g, "_");

      const fileItem =
        type === "excel"
          ? generateXlsxBlobAndName(exportRowsAll, filenameBase)
          : generateCsvBlobAndName(exportRowsAll, filenameBase);

      // trigger download (same utility as your handleDownload)
      const triggerBlobDownload = (blob, filename) => {
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.setAttribute("download", filename);
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
        showToast("Download Successfull", "success", 2000);
      };

      triggerBlobDownload(fileItem.blob, fileItem.filename);
    } catch (err) {
      console.error("Error during download all single table:", err);
      showToast("Download failed", "error", 2000);
    }
  };

  // if (selectedReport) {
  // const reportData = rows?.find((r) => r?.reportName?.id === selectedReport);

  return (
    <div className="flex-1 flex flex-col overflow-hidden">
      <Button
        title={`${selectedReport?.reportName}`}
        color="black"
        variant="text"
        size="md"
        fromLeft
        icon="arrow_left_alt"
        className="self-start text-lg font-semibold"
        onClick={() => setSelectedReport(null)}
      />

      <div className="flex-1 overflow-auto">
        <TableAdv
          columns={columns2}
          rows={submissionRows}
          showCheckbox={true}
          rowClickeble={false}
          page={page}
          limit={limit}
          onPaginationChange={setPage}
          onLimitChange={handleLimitChange}
          onSelectionChange={(ids) => setSelectedIds(ids)}
          defaultSelectedRows={selectedIds}
          showSlNo={false}
          totalCount={Number(raReportsData?.raReports?.data?.totalCount)}
          className="text-blue-600"
          tableId={"reports_ats_rareport_radownloadsheet"}
          accordion={(row2, accordionType) => (
            <AccrodianComponent data={row2} type={accordionType} />
          )}
          serverPagination={true}
          toolbarRight={{
            search: true,
            filter: true,
            download: false,
            add: [
              {
                component: (
                  <div className="flex items-center gap-2">
                    <div className="relative inline-block">
                      <Button
                        type="icon"
                        variant="text"
                        color="black"
                        icon="ios_share"
                        onClick={() => setShowOptions((prev) => !prev)}
                      />
                      {showOptions && (
                        <div className="absolute right-0 mt-3 pt-2 w-60 bg-white border border-gray-200 rounded-lg shadow-lg z-50">
                          <Button
                            title="Download as Excel"
                            variant="text"
                            color="black"
                            className="w-full text-left px-3 py-1 hover:bg-gray-100"
                            onClick={() => {
                              handleDownload("excel");
                              setShowOptions(false);
                            }}
                          />
                          <Button
                            title="Download as CSV"
                            variant="text"
                            color="black"
                            className="w-full text-left px-3 py-1 hover:bg-gray-100"
                            onClick={() => {
                              handleDownload("csv");
                              setShowOptions(false);
                            }}
                          />
                          <Button
                            title="Download All Sheets as Excel"
                            variant="text"
                            color="black"
                            className="w-full text-left px-3 py-1 hover:bg-gray-100"
                            onClick={() => {
                              handleDownloadAll("excel");
                              setShowOptions(false);
                            }}
                          />
                          <Button
                            title="Download All Sheets as CSV"
                            variant="text"
                            color="black"
                            className="w-full text-left px-3 py-1 hover:bg-gray-100"
                            onClick={() => {
                              handleDownloadAll("csv");
                              setShowOptions(false);
                            }}
                          />
                        </div>
                      )}
                    </div>
                    <FormFieldSet
                      noTitle
                      placeholder="Select date range"
                      type="datepickerRange"
                      size="sm"
                      value={dateRange}
                      onChange={(range) => {
                        console.log("test", range);

                        handleDateRangeChange(range);
                      }}
                      shadow={true}
                    />
                    <Backdrop isOpen={loading?.loading||withinPageLoading} zIndex={52}>
                      <LogoLoader />
                    </Backdrop>
                  </div>
                ),
              },
            ],
          }}
        />
      </div>
     
    </div>
  );
  // }

  // return (
  //   <div className="flex-1 flex flex-col overflow-hidden">
  //     <NewTableAdv
  //       disableSelection={true}
  //       columns={columns}
  //       rows={mappedRows}
  //       page={page}
  //       limit={limit}
  //       showCheckbox={false}
  //       showSlNo
  //       toolbarRight={{ search: true }}
  //       // tableId={"newTableForTesting"}
  //       tableId={"raReportsTable"}
  //     />
  //   </div>
  // );
};

export default RaReports;
